import React, { useEffect, useState } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "products"));
        const productsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productsList);
      } catch (error) {
        console.error("خطأ أثناء جلب البيانات:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("هل أنت متأكد أنك تريد حذف هذا المنتج؟");
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "products", id));
      setProducts(products.filter((product) => product.id !== id));
      alert("✅ تم حذف المنتج بنجاح");
    } catch (error) {
      console.error("خطأ أثناء حذف المنتج:", error);
    }
  };

  const handleEdit = (id) => {
    navigate(`/admin/edit-product/${id}`);
  };

  if (loading)
    return <p style={styles.loadingText}>⏳ جاري تحميل المنتجات...</p>;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>📦 قائمة المنتجات</h1>

      {products.length === 0 ? (
        <p style={styles.noProducts}>لا توجد منتجات بعد</p>
      ) : (
        <div style={styles.grid}>
          {products.map((product) => (
            <div key={product.id} style={styles.card}>
              <img
                src={product.imageUrl}
                alt={product.name}
                style={styles.image}
              />
              <div style={styles.cardContent}>
                <h2 style={styles.name}>{product.name}</h2>
                <p style={styles.description}>{product.description}</p>
                <p style={styles.price}>{product.price} جنيه</p>

                <div style={styles.buttons}>
                  <button
                    onClick={() => handleEdit(product.id)}
                    style={{ ...styles.btn, ...styles.editBtn }}
                  >
                    ✏️ تعديل
                  </button>
                  <button
                    onClick={() => handleDelete(product.id)}
                    style={{ ...styles.btn, ...styles.deleteBtn }}
                  >
                    🗑️ حذف
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// 🎨 CSS Styles داخل نفس الملف
const styles = {
  container: {
    padding: "40px 20px",
    backgroundColor: "#f3f4f6",
    minHeight: "100vh",
    fontFamily: "Tahoma, sans-serif",
  },
  title: {
    fontSize: "30px",
    fontWeight: "bold",
    textAlign: "center",
    color: "#1f2937",
    marginBottom: "40px",
  },
  loadingText: {
    textAlign: "center",
    marginTop: "100px",
    fontSize: "20px",
    color: "#6b7280",
  },
  noProducts: {
    textAlign: "center",
    color: "#6b7280",
    fontSize: "18px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "30px",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "pointer",
  },
  image: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
  },
  cardContent: {
    padding: "18px",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  name: {
    fontSize: "20px",
    fontWeight: "600",
    marginBottom: "10px",
    color: "#111827",
  },
  description: {
    color: "#4b5563",
    fontSize: "15px",
    marginBottom: "12px",
    lineHeight: "1.6",
  },
  price: {
    fontWeight: "bold",
    color: "#10b981",
    textAlign: "right",
    fontSize: "16px",
    marginBottom: "14px",
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
  },
  btn: {
    border: "none",
    borderRadius: "8px",
    padding: "8px 14px",
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  editBtn: {
    backgroundColor: "#f59e0b",
    color: "#fff",
  },
  deleteBtn: {
    backgroundColor: "#ef4444",
    color: "#fff",
  },
};

export default Products;